import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import RequestSuccessComponent from './request-success.component';

let RequestSuccessModule = angular
  .module('RequestSuccess', [
    uiRouter
  ])
  .component('requestSuccess', RequestSuccessComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('requestSuccess', {
      params: {
        email: null
      },
      url: '/request-success',
      views: {
        'menu': "",
        'content': {
          component: 'requestSuccess'
        }
      },
      resolve: {
        email: ($transition$) => {
          return $transition$.params().email || '';
        }
      }
    })
  })
  .name;

export default RequestSuccessModule;



// WEBPACK FOOTER //
// ./src/app/pages/request-success/request-success.module.js